export const getFeatureValue = feature => {
    if (feature.hasOption) {
        if (feature.productOptionValue === -1) return 'Unlimited'
        return feature.productOptionValue
    }
    return feature.enabled ? 'Yes' : 'No'
}
